import React from 'react';
import {
    DoppeActionTypeWidgetContentLayoutNew
} from '../doppe-action-type-widget-content-layout-new/doppe-action-type-widget-content-layout-new';
import {OmitStrict} from '@wix/devzai-utils-common';
import {useIsWidgetInFixedHeight} from "../doppe-viewer-widget-rendering-context/doppe-viewer-widget-rendering-context";

export const DoppeActionTypeWidgetContentLayoutNewWrapper = React.memo(function DoppeActionTypeWidgetContentLayoutNewWrapper (props: DoppeActionTypeWidgetContentLayoutNewWrapper.Props) {

    const isWidgetInFixedHeight = useIsWidgetInFixedHeight();

    return (
        <DoppeActionTypeWidgetContentLayoutNew
            {...props}
            isFixedHeight={isWidgetInFixedHeight}
            fullWidthMainMedia={props.fullWidthMainMedia ?? isWidgetInFixedHeight ? true : undefined}
        />
    );
});

export namespace DoppeActionTypeWidgetContentLayoutNewWrapper {

    export interface Props extends OmitStrict<DoppeActionTypeWidgetContentLayoutNew.Props, 'isFixedHeight'> {
    }
}
